import { ModuleFE_SmartDoc } from './ModuleFE_SmartDoc.js';
export const ModulePackFE_SmartDocDB = [ModuleFE_SmartDoc];
//# sourceMappingURL=module-pack.js.map